/**
 * SyncFreshnessDot — small colored dot indicating outbound sync health.
 *
 * Green: synced < 1 hour ago
 * Amber: synced > 24 hours ago
 * Red: last push failed
 * No dot: never synced outbound, or synced 1-24h ago (normal)
 *
 * Plan 192, Epic 04.
 */

interface SyncFreshnessDotProps {
  lastOutboundSync?: string;
  lastOutboundStatus?: "Success" | "Failed";
}

export function SyncFreshnessDot({ lastOutboundSync, lastOutboundStatus }: SyncFreshnessDotProps) {
  // Never synced outbound — no dot (per user story: "Never synced outbound = No dot")
  if (!lastOutboundSync) return null;

  // Failed push — red dot
  if (lastOutboundStatus === "Failed") {
    return <span className="inline-block w-2 h-2 rounded-full bg-red-500" title="Push failed" />;
  }

  const hours = (Date.now() - new Date(lastOutboundSync).getTime()) / (1000 * 60 * 60);

  // Synced < 1 hour — green
  if (hours < 1) {
    return <span className="inline-block w-2 h-2 rounded-full bg-green-500" title="Synced recently" />;
  }

  // Synced > 24 hours — amber (stale)
  if (hours > 24) {
    return <span className="inline-block w-2 h-2 rounded-full bg-amber-500" title="Sync is stale" />;
  }

  // 1-24 hours — normal, no dot
  return null;
}
